<template>
    <div id="app" class="h-100">
        <router-view />
    </div>
</template>

<script>
	  export default {
      // mounted() {
      //     window.addEventListener('beforeunload', this.handleBeforeUnload);
      // },
      // beforeDestroy() {
      //     window.removeEventListener('beforeunload', this.handleBeforeUnload);
      // },
      // methods: {
      //     handleBeforeUnload(event) {
      //         const message = 'É possível que as alterações feitas não sejam salvas.';
      //         event.returnValue = message;
      //         return message;
      //     }
      // }
    };
</script>



<style>
    #app {
        min-width: 256px;
    }

    #app.with-iframe {
        overflow: hidden;
    }

    .click-to-pay-iframe-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(199,199,199,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
    }

    @media (min-width: 496px) {
        .click-to-pay-iframe-container {
            padding: 16px 0;
        }
    }

    .click-to-pay-iframe {
        min-width: 320px;
        max-width: 480px;
        max-height: 820px;
        width: 100%;
        height: 100%;
        border: none;
    }

    /* scrollbar do componente de bottom sheet */
    .cielo-scrollbar,
    .bottom-sheet__main {
      margin-right: 24px;

      /* firefox css fix */
      scrollbar-color: #0774E7 #EAEEF3;
      scrollbar-width: thin;
    }
    .cielo-scrollbar::-webkit-scrollbar,
    .bottom-sheet__main::-webkit-scrollbar {
      width: 4px !important;
    }
    .cielo-scrollbar::-webkit-scrollbar-track,
    .bottom-sheet__main::-webkit-scrollbar-track {
      background: #EAEEF3 !important;
      border-radius: 8px !important;
    }
    .cielo-scrollbar::-webkit-scrollbar-thumb,
    .bottom-sheet__main::-webkit-scrollbar-thumb {
      background-color: #0774E7 !important;
      border-radius: 8px !important;
    }


    /* INICIO
      classe css que ajuda na hora de fazer o grid de cada view do c2p
      a expandir até o final da tela com relação a altura
    */
    .c2p-container {
        @media screen and (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
        }
    }

    .c2p-container > div:first-of-type {
        @media screen and (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
        }
    }

    /* Previnir que strings infinitas deixem de quebrar*/
    p,
    span,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        overflow-wrap: break-word;
    }

    /* remoção de outline para elementos que servem como ponto de partida para acessibilidade */
    .starting-point:focus {
        outline: none;
    }

</style>
